import { createAction } from '@reduxjs/toolkit'

export const applicationChange = createAction('application/change')
